import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

import MyDatePicker from 'components/Shared/MyDatePicker';

const DemandeEnlevement = ({ piece, onChange }) => {

    // Clé technique pour les appels API (BL ou DT) — fallback sur numeroPiece pour le legacy
    const cleApi = piece?.bonLivraisonGestionCle || piece?.demandeTransfertGestionCle || piece?.numeroPiece;

    const [fetchingPiece, setFetchingPiece] = React.useState(true);

    const [pieceGestion, setPieceGestion] = React.useState(null);
    const [pieceGestionLignes, setPieceGestionLignes] = React.useState(null);

    const [enlevement, setEnlevement] = React.useState(null);



    // Au montage
    React.useEffect(() => {
        const fetchData = async () => {

            axios.get(`api/pieces-gestion?type=piece&numeroPiece=${piece?.numeroPiece || cleApi}`)
                .then((response) => {

                    //console.log(response);

                    setPieceGestion({ ...response.data[0] });

                })
                .catch((error) => {

                    console.log(error);

                })
                .then(() => {
                    // always executed
                    //setFetchingPiece(false);
                });


            axios.get(`api/piece-gestion-lignes?numeroPiece=${cleApi}&logistiqueInfos=true`)
                .then((response) => {

                    //console.log(response);

                    setPieceGestionLignes(response.data);

                })
                .catch((error) => {

                    console.log(error);

                })
                .then(() => {
                    // always executed
                    setFetchingPiece(false);
                });
        };

        fetchData();
    }, []);


    React.useEffect(() => {

        if (pieceGestion && pieceGestionLignes) {

            //console.log('pieceGestionLignes', pieceGestionLignes);

            let newEnlevement = {
                adresseEnlevementNomLivraison: pieceGestion.adresseLivraison.nomLivraison,
                adresseEnlevementAdresse1: pieceGestion.adresseLivraison.adresse1,
                adresseEnlevementAdresse2: pieceGestion.adresseLivraison.adresse2,
                adresseEnlevementCodePostal: pieceGestion.adresseLivraison.codePostal,
                adresseEnlevementVille: pieceGestion.adresseLivraison.ville,

                contactClientNom: pieceGestion.donneurOrdre.nom,
                contactClientEmail: pieceGestion.donneurOrdre.mail,
                contactClientTelephone: pieceGestion.donneurOrdre.telephoneMobile,

                adresseDestinationNom: '',
                adresseDestinationAdresse1: '',
                adresseDestinationAdresse2: '',
                adresseDestinationCodePostal: '',
                adresseDestinationVille: '',

                dateSouhaitee: null,
                poidsTheorique: pieceGestionLignes.reduce((c,v) => c + (v.poids === null ? 0 : v.poids), 0),
                nbPalettes: 0,
                nbColis: 0,
                nbLongueurs: 0,
            };

            //console.log('newEnlevement', newEnlevement);

            setEnlevement(newEnlevement);
        }


    }, [pieceGestion, pieceGestionLignes]);



    // Sur le changement, on les notifie au parent.
    React.useEffect(() => {
        onChange(enlevement);
    }, [enlevement]);



    // Changement d'une composante de l'enlèvement
    const handleChange = (e) => {
        let newEnlevement = {
            ...enlevement,
            [e.target.name]: e.target.value
        }
        setEnlevement(newEnlevement);
    }

    // Changement d'une composante "integer" de l'enlèvement
    const handleChangeInteger = (e) => {

        let newEnlevement = {
            ...enlevement,
            [e.target.name]: Math.max(e.target.value, 0)
        }
        setEnlevement(newEnlevement);
    }



    if (!enlevement) {
        return <Skeleton />
    }

    return (

        <Paper sx={{ padding: '8px', backgroundColor: '' }}>

            <>Demande d'enlevement de : {piece?.numeroPiece}</>

            <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                    <Paper sx={{ padding: '8px', backgroundColor: '' }}>
                        <Stack spacing={1} mt={1}>
                            <Typography variant="h6" gutterBottom>{`Adresse d'enlèvement :`}</Typography>
                            <TextField required name="adresseEnlevementNomLivraison" label="Nom" value={enlevement.adresseEnlevementNomLivraison} onChange={e => handleChange(e)} fullWidth />
                            <TextField required name="adresseEnlevementAdresse1" label="Adresse" value={enlevement.adresseEnlevementAdresse1} onChange={e => handleChange(e)} fullWidth />
                            <TextField name="adresseEnlevementAdresse2" label="Complément" value={!enlevement.adresseEnlevementAdresse2 ? '' : enlevement.adresseEnlevementAdresse2} onChange={e => handleChange(e)} fullWidth />

                            <Grid container spacing={0}>
                                <Grid item xs={4} >
                                    <TextField sx={{ marginRight: '8px' }} required name="adresseEnlevementCodePostal" label="Code Postal" value={enlevement.adresseEnlevementCodePostal} onChange={e => handleChange(e)} />

                                </Grid>
                                <Grid item xs={8}>
                                    <TextField required fullWidth name="adresseEnlevementVille" label="Ville" value={enlevement.adresseEnlevementVille} onChange={e => handleChange(e)} />
                                </Grid>
                            </Grid>
                        </Stack>
                    </Paper>
                </Grid>
                <Grid item xs={6}>
                    <Paper sx={{ padding: '8px', backgroundColor: '' }}>
                        <Stack spacing={1} mt={1}>
                            <Typography variant="h6" gutterBottom>{`Adresse de destination :`}</Typography>
                            <TextField required name="adresseDestinationNom" label="Nom" value={enlevement.adresseDestinationNom} onChange={e => handleChange(e)} fullWidth autoFocus />
                            <TextField required name="adresseDestinationAdresse1" label="Adresse" value={enlevement.adresseDestinationAdresse1} onChange={e => handleChange(e)} fullWidth />
                            <TextField name="adresseDestinationAdresse2" label="Complément" value={enlevement.adresseDestinationAdresse2} onChange={e => handleChange(e)} fullWidth />

                            <Grid container spacing={0}>
                                <Grid item xs={4} >
                                    <TextField sx={{ marginRight: '8px' }} required name="adresseDestinationCodePostal" label="Code Postal" value={enlevement.adresseDestinationCodePostal} onChange={e => handleChange(e)} />
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField required fullWidth name="adresseDestinationVille" label="Ville" value={enlevement.adresseDestinationVille} onChange={e => handleChange(e)} />
                                </Grid>
                            </Grid>
                        </Stack>
                    </Paper>
                </Grid>
                <Grid item xs={6}>
                    <Paper sx={{ padding: '8px', backgroundColor: '' }}>
                        <Stack spacing={1} mt={1}>
                            <Typography variant="h6" gutterBottom>Contact client nécessaire à l'enlèvement :</Typography>
                            <TextField required name="contactClientNom" label="Nom" value={enlevement.contactClientNom} onChange={e => handleChange(e)} fullWidth />
                            <TextField required name="contactClientEmail" label="Email" value={enlevement.contactClientEmail} onChange={e => handleChange(e)} fullWidth />
                            <TextField required name="contactClientTelephone" label="Téléphone" value={enlevement.contactClientTelephone} onChange={e => handleChange(e)} fullWidth />
                        </Stack>
                    </Paper>
                </Grid>
                <Grid item xs={6}>

                    <Paper sx={{ padding: '8px', backgroundColor: '' }}>
                        <Stack spacing={1} mt={1}>
                            <Typography variant="h6" gutterBottom>Expédition :</Typography>

                            <MyDatePicker
                                label="Date d'enlèvement souhaitée"
                                name={"dateSouhaitee"}
                                value={enlevement.dateSouhaitee}
                                onChange={e => {
                                    handleChange({ target: { name: "dateSouhaitee", value: e } });
                                }}
                                disableSunday={true}
                                disablePast={true}
                                fullWidth
                                disabled={false}
                                required={false}
                            />

                            <TextField required name="poidsTheorique" label="Poids théorique (en g)" value={enlevement.poidsTheorique} onChange={handleChangeInteger} fullWidth />
                            <Stack direction={"row"} justifyContent="space-between" spacing={1} mt={1} >
                                <TextField fullWidth name="nbPalettes" label="Nombre de palettes" type="number" value={enlevement.nbPalettes} onChange={handleChangeInteger} />
                                <TextField fullWidth name="nbColis" label="Nombre de colis" type="number" value={enlevement.nbColis} onChange={handleChangeInteger} />
                                <TextField fullWidth name="nbLongueurs" label="Nombre de longueurs" type="number" value={enlevement.nbLongueurs} onChange={handleChangeInteger} />
                            </Stack>
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>        
        </Paper>

    );
}


DemandeEnlevement.propTypes = {
    piece: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};

export default DemandeEnlevement;